import { render, staticRenderFns } from "./DettaglioProfilo.vue?vue&type=template&id=47bb67aa"
import script from "./DettaglioProfilo.vue?vue&type=script&lang=js"
export * from "./DettaglioProfilo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports